import * as mutationTypes from './mutationTypes';

const mutations = {
  [mutationTypes.FETCH_BRANDS](state) {
    state.fetchingBrands = true;
    state.errorFetchingBrands = null;
  },
  [mutationTypes.DONE_FETCHING_BRANDS](state, { brands }) {
    state.fetchingBrands = false;
    state.brands = brands;
  },
  [mutationTypes.ERROR_FETCHING_BRANDS](state, { error }) {
    state.fetchingBrands = false;
    state.errorFetchingBrands = error;
  },

  [mutationTypes.FETCH_BRAND](state) {
    state.brand = null;
    state.fetchingBrand = true;
    state.errorFetchingBrand = null;
  },
  [mutationTypes.DONE_FETCHING_BRAND](state, { brand }) {
    state.fetchingBrand = false;
    state.brand = brand;
  },
  [mutationTypes.ERROR_FETCHING_BRAND](state, { error }) {
    state.fetchingBrand = false;
    state.errorFetchingBrand = error;
  },

  [mutationTypes.FETCH_BRAND_FEEDBACK](state) {
    state.brandFeedback = null;
    state.fetchingBrandFeedback = true;
    state.errorFetchingBrandFeedback = null;
  },
  [mutationTypes.DONE_FETCHING_BRAND_FEEDBACK](state, { feedback }) {
    state.fetchingBrandFeedback = false;
    state.brandFeedback = feedback;
  },
  [mutationTypes.ERROR_FETCHING_BRAND_FEEDBACK](state, { error }) {
    state.fetchingBrandFeedback = false;
    state.errorFetchingBrandFeedback = error;
  },

  [mutationTypes.CREATE_BRAND](state) {
    state.errorCreatingBrand = null;
    state.creatingBrand = true;
    state.lastCreatedBrand = null;
  },
  [mutationTypes.DONE_CREATING_BRAND](state, { brand }) {
    state.creatingBrand = false;
    state.lastCreatedBrand = brand;
  },
  [mutationTypes.ERROR_CREATING_BRAND](state, { error }) {
    state.errorCreatingBrand = error;
    state.creatingBrand = false;
  },

  [mutationTypes.UPDATE_BRAND](state) {
    state.errorUpdatingBrand = null;
    state.updatingBrand = true;
  },
  [mutationTypes.DONE_UPDATING_BRAND](state, { brand }) {
    state.updatingBrand = false;
    state.brand = brand;
  },
  [mutationTypes.ERROR_UPDATING_BRAND](state, { error }) {
    state.errorUpdatingBrand = error;
    state.updatingBrand = false;
  },
  [mutationTypes.UPDATE_AND_REVET_BRAND](state) {
    state.errorUpdatingAndRevettingBrand = null;
    state.updatingAndRevettingBrand = true;
  },
  [mutationTypes.DONE_UPDATING_AND_REVETIING_BRAND](state, { brand }) {
    state.updatingAndRevettingBrand = false;
    state.brand = brand;
  },
  [mutationTypes.ERROR_UPDATING_AND_REVETTING_BRAND](state, { error }) {
    state.errorUpdatingAndRevettingBrand = error;
    state.updatingAndRevettingBrand = false;
  },

  [mutationTypes.DEACTIVATE_BRAND](state) {
    state.errorDeactivatingBrand = null;
    state.deactivatingBrand = true;
  },
  [mutationTypes.DONE_DEACTIVATING_BRAND](state, { brand }) {
    state.deactivatingBrand = false;
    state.deactivatedBrand = brand;
  },
  [mutationTypes.ERROR_DEACTIVATING_BRAND](state, { error }) {
    state.errorDeactivatingBrand = error;
    state.deactivatingBrand = false;
  },

  [mutationTypes.REMOVE_CREATION_ERRORS](state, { key } = {}) {
    if (!!state.errorCreatingBrand && typeof state.errorCreatingBrand === 'object') {
      state.errorCreatingBrand[key] = null;
      if (Object.keys(state.errorCreatingBrand).some(errKey => !!state.errorCreatingBrand[errKey])) return;
    }
    state.errorCreatingBrand = null;
  },
  [mutationTypes.REMOVE_UPDATE_ERROR](state, { key } = {}) {
    if (!!state.errorUpdatingBrand && typeof state.errorUpdatingBrand === 'object' && key) {
      state.errorUpdatingBrand[key] = null;
      if (Object.keys(state.errorUpdatingBrand).some(errKey => !!state.errorUpdatingBrand[errKey])) return;
    }
    state.errorUpdatingBrand = null;
  },
  [mutationTypes.REMOVE_DEACTIVATION_ERROR](state) {
    state.errorDeactivatingBrand = null;
  },
  [mutationTypes.REMOVE_LAST_CREATED_BRAND](state) {
    state.lastCreatedBrand = null;
  },

  [mutationTypes.CHANGE_BRANDS_LIST_VIEW](state, { isListView }) {
    state.isListView = isListView;
  },
  [mutationTypes.REMOVE_LAST_DEACTIVATED_BRAND](state) {
    state.deactivatedBrand = null;
  },
};

export default mutations;
